import { lazy } from 'react';

export const PlayerCountryForm = lazy(() => import('./PlayerCountryForm'));
